import { useState } from "react";

/** F1/UC13 — seeded login (D3). Calls Better Auth's email/password endpoint. */
export function LoginForm({ onSuccess }: { onSuccess: () => void }) {
  const [email, setEmail] = useState("executive@example.com");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    const res = await fetch("/api/auth/sign-in/email", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ email, password }),
    });
    setBusy(false);
    if (res.ok) onSuccess();
    else setError("Login fehlgeschlagen");
  }

  return (
    <div className="grid min-h-full place-items-center bg-neutral-50 dark:bg-neutral-950">
      <form
        onSubmit={submit}
        data-testid="login"
        className="w-80 rounded-xl border border-neutral-200 bg-white p-6 shadow-sm dark:border-neutral-800 dark:bg-neutral-900"
      >
        <h1 className="mb-1 text-lg font-semibold">Knowledge Bot</h1>
        <p className="mb-4 text-sm text-neutral-500">Anmelden</p>
        <input
          data-testid="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="E-Mail"
          className="mb-2 w-full rounded-md border border-neutral-300 px-3 py-2 text-sm outline-none focus:border-blue-500 dark:border-neutral-700 dark:bg-neutral-800"
        />
        <input
          data-testid="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Passwort"
          className="mb-3 w-full rounded-md border border-neutral-300 px-3 py-2 text-sm outline-none focus:border-blue-500 dark:border-neutral-700 dark:bg-neutral-800"
        />
        {error && <p className="mb-2 text-sm text-red-600">{error}</p>}
        <button
          type="submit"
          disabled={busy}
          className="w-full rounded-md bg-blue-600 px-3 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50"
        >
          {busy ? "…" : "Login"}
        </button>
        <p className="mt-3 text-xs text-neutral-400">Seeded-Login (D3). Kein Self-Signup.</p>
      </form>
    </div>
  );
}
